import QuestionnaireAnswer from './QuestionnaireAnswer'

export {
  QuestionnaireAnswer
}


// WEBPACK FOOTER //
// ./src/screens/Questionnaire/QuestionnaireAnswer/index.js